import gql from "graphql-tag";

export default gql`
  fragment LockablePostFields on LockablePost {
    isLocked
    lockedBy {
      _id
      fullName
    }
  }
`;
